import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks";
import { formatterDate, normativa, optionsFormatter } from "../../../utils";
import { GetAllTraining, resetGetAllTrainingsStatus } from "./slice";

export function BoxFormazioneSingle() {
    const dispatch = useAppDispatch()
    const trainingState = useAppSelector(state => state.PMTraining)
    const PMState = useAppSelector(state => state.personalManagement)

    useEffect(() => {
        dispatch(GetAllTraining({ itemsPerPage: 30, personalManagementId: PMState.currentPersonalManagementId }))
    }, [])

    useEffect(() => {
        if (
            trainingState.getAllTrainingsStatus === 'successfully' &&
            trainingState.getAllTrainingsResponse !== undefined
        ) {
            dispatch(resetGetAllTrainingsStatus())
        }
    }, [trainingState.getAllTrainingsStatus])

    const handleNorms = (subs: string[]) => {
        if (subs === null) return ''
        return subs.slice(0, -1).map(s => `${optionsFormatter(s, normativa)} - `) +
            optionsFormatter(subs[subs.length - 1], normativa)!
    }

    return (
        <div className="p-6">
            <div className="space-y-3">
                <span className="font-bold text-2xl text-neutral-850">Formazione</span>

                <div className="w-full overflow-x-auto rounded-xl border border-neutral-200 shadow-sm">
                    <table className="w-full border-collapse text-text-md min-w-[900px]">
                        <thead>
                            <tr className="bg-brandPrimary-600 text-white uppercase text-xs tracking-wide h-[52px]">
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tl-xl">Dal / Al</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Crediti</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Tipo di Formazione</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Normativa</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Argomenti Trattati</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tr-xl">Altri Dati</th>
                            </tr>
                        </thead>
                        <tbody>
                            {!trainingState.getAllTrainingsResponse || trainingState.getAllTrainingsResponse.data.length === 0 ? (
                                <tr>
                                    <td colSpan={6} className="px-3 py-3 text-left text-neutral-500 bg-white">
                                        Nessuna formazione trovata
                                    </td>
                                </tr>
                            ) : (
                                trainingState.getAllTrainingsResponse.data.map((training, index) => (
                                    <tr
                                        key={training.id}
                                        className={`text-left border-b border-neutral-200 transition-colors duration-150 hover:bg-brandPrimary-50 ${index % 2 === 0 ? 'bg-white' : 'bg-neutral-50'}`}
                                    >
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            <div>{formatterDate(training.starting)}</div>
                                            <div>{formatterDate(training.ending)}</div>
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {training.credits}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {training.webinar ? 'Webinar' : 'In Presenza'}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700">
                                            <ul className="list-disc list-inside space-y-1">
                                                {training.trainingActivities.map((t, i) => (
                                                    <li key={i}>{handleNorms(t.norms!)}</li>
                                                ))}
                                            </ul>
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700">
                                            {training.topicsCovered}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700">
                                            {training.otherData}
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}